module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.getValue))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77d100e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/ValueComponent.vue
// module id = 1328
// module chunks = 2